import { createTV, defaultConfig } from 'tailwind-variants';

defaultConfig.twMerge = false;
export const tv = createTV({
  twMerge: false,
});

export const tvt = tv;
